<div class="w-100 border-radius-3 overflow-hidden bg-orange">
  <div
    class="flex align-items-center gap-2 px-4 p-3 text-10 bold-700 uppercase color-light bg-orange-500">
    <shared-icon class="fill-light" icon="triangle-exclamation" size="large" />
    <span>
      {{ headline }}
    </span>
  </div>
  <div class="px-4 py-3 color-light text-14 bold-500">
    <ng-content />

    @if (buttonLabel) {
      <button class="p-button p-button-primary mt-4" (click)="buttonClick.emit()">
        {{ buttonLabel }}
      </button>
    }
  </div>
</div>
